// assets
import { 
  AppstoreOutlined, 
  PlusOutlined, 
  SettingOutlined 
} from '@ant-design/icons';

// icons
const icons = {
  AppstoreOutlined,
  PlusOutlined,
  SettingOutlined
};

// ==============================|| MENU ITEMS - MODULES ||============================== //

const modules = {
  id: 'group-modules',
  title: 'Модули системы',
  type: 'group',
  children: [
    {
      id: 'modules-list',
      title: 'Все модули',
      type: 'item',
      url: '/modules',
      icon: icons.AppstoreOutlined,
      breadcrumbs: false
    },
    {
      id: 'modules-create',
      title: 'Создать модуль',
      type: 'item',
      url: '/modules/create',
      icon: icons.PlusOutlined,
      breadcrumbs: false
    }
  ]
};

export default modules;
